/* FLÁYR – voegt onder elke horizontaal scrollbare productrij (scroll-carousel) een schuifbalkje toe
   dat meebeweegt met het swipen. Verborgen als de rij niet breder is dan het scherm. */
(function () {
  var updaters = [];

  function init(carousel) {
    if (carousel.dataset.flayrBar) return;
    carousel.dataset.flayrBar = '1';

    var bar = document.createElement('div');
    bar.className = 'flayr-scrollbar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'flayr-scrollbar__thumb';
    bar.appendChild(thumb);

    var anchor = carousel.closest('product-list') || carousel;
    anchor.parentNode.insertBefore(bar, anchor.nextSibling);

    function update() {
      var max = carousel.scrollWidth - carousel.clientWidth;
      if (max < 4) { bar.hidden = true; return; }
      bar.hidden = false;
      var track = bar.clientWidth;
      var size = Math.max(track * carousel.clientWidth / carousel.scrollWidth, 24);
      var progress = Math.min(Math.abs(carousel.scrollLeft) / max, 1);
      thumb.style.width = size + 'px';
      thumb.style.transform = 'translateX(' + progress * (track - size) + 'px)';
    }

    carousel.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(carousel);
    updaters.push(update);
    update();
  }

  function scan() {
    document.querySelectorAll('scroll-carousel.product-list--carousel').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', function () { updaters.forEach(function (u) { u(); }); });
  document.addEventListener('shopify:section:load', scan);
})();
